/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */

export enum compositionTypeEnum {
  NONE = 'None',
  JOURNEY_IDENTIFIER = 'JourneyIdentifier',
  JOURNEY_IDENTIFIER_PRICE_CATEGORY = 'JourneyIdentifierPriceCategory',
  JOURNEY_IDENTIFIER_PRICE_CATEGORY_CABIN_TYPE = 'JourneyIdentifierPriceCategoryCabinType',
  JOURNEY_IDENTIFIER_WITHOUT_PRODUCT_TYPE = 'JourneyIdentifierWithoutProductType',
}
